<template>
<div class="statement">
  <div class="card">
    <div class="title">{{$t('Register.declare')}}</div>
    <section class="line-box">
      <div><el-checkbox v-model="alreadyRisk"></el-checkbox></div>
      <div>
        {{$t('I_have_read_understood_and_agreed')}}
        <span class="theme-color">
          <a
            class="file font333 pointer"
            :href="Privacy"
            target="_blank"
          >《{{$t('Privacy_agreement')}}》</a>
        </span>
        <span class="theme-color">
          <a
            class="file font333 pointer"
            :href="RiskStatement"
            target="_blank"
          >《{{$t('riskFileName')}}》</a>
        </span>
        <span class="theme-color">
          <a
            class="file font333 pointer"
            :href="ToPreventMoneyLaundering"
            target="_blank"
          >《{{$t('Prevent_money_laundering')}}》</a>
        </span>
        <span class="theme-color">
          <a
            class="file font333 pointer"
            :href="safety_instructions"
            target="_blank"
          >《{{$t('safety_instructions')}}》</a>
        </span>
        {{period}}
      </div>
    </section>
    <section class="line-box">
      <div><el-checkbox v-model="fitMe"></el-checkbox></div>
      <div>{{$t('User.openAccTips3')}}{{period}}</div>
    </section>
    <section class="line-box">
      <div><el-checkbox v-model="bearMe"></el-checkbox></div>
      <div>{{$t('User.openAccTips4')}}{{period}}</div>
    </section>
    <section class="line-box">
      <div><el-checkbox v-model="lever"></el-checkbox></div>
      <div>{{$t('User.openAccTips5')}}</div>
    </section>
    <section class="line-box">
      <div><el-checkbox v-model="sendMes"></el-checkbox></div>
      <div>{{$t('User.openAccTips6')}}</div>
    </section>
    <section class="des line-box">
      <div><el-checkbox v-model="other"></el-checkbox></div>
      <div>{{$t('User.openAccTips7')}}</div>
    </section>
  </div>
  <div class="btn-line">
    <vs-button
      color="primary"
      type="border"
      class="next-btn"
      @click="prevHandle">{{$t('root.upper')}}</vs-button>
    <vs-button
      :disabled="disabledFlag"
      @click="submitHandle"
    >{{$t('User.sumit')}}</vs-button>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "statementContent",
  data() {
    return {
      alreadyRisk: false,
      fitMe:false,
      bearMe:false,
      lever:false,
      sendMes:false,
      other:false,
    }
  },
  computed:{
    ...mapGetters(['Privacy','RiskStatement','userInfo','language','ToPreventMoneyLaundering','safety_instructions']),
    disabledFlag(){
      if(this.alreadyRisk && this.fitMe === true && this.bearMe === true && this.lever === true && this.sendMes === true && this.other === true){
        return false
      }else {
        return true;
      }
    },
    period(){
      if(this.language == 'zh_CN'){
        return '。'
      }else {
        return '.'
      }
    }
  },
  methods: {
    prevHandle(){
      this.$emit('prev-step');
    },
    submitHandle() {
      this.$emit('submit');
    }
  },
}
</script>

<style lang="scss" scoped>
.statement {
  .line-box{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    &>div{
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 14px;
      &:first-child{
        margin-right: 7px;
      }
      &:last-child{
      }
    }
  }
}

</style>
